import {TrackingApiDto} from "../../api/model/rest";
import {none, Option, option} from "ts-option";
import JsonConverter from "../../api/helper/JsonConverter";

export default class TrackingData {

	public static fromJson(json: TrackingApiDto): TrackingData {
		const campaign = json.campaign ? option(json.campaign) : none;
		const source = json.source ? option(json.source) : none;
		const adGroup = json.adGroup ? option(json.adGroup) : none;
		const landingPage = json.landingPage ? option(json.landingPage) : none;
		const url = json.url ? option(json.url) : none;

		return new TrackingData(campaign, source, adGroup, landingPage, url)
	}

	constructor(public readonly campaign: Option<string>,
		public readonly source: Option<string>,
		public readonly adGroup: Option<string>,
		public readonly landingPage: Option<string>,
		public readonly url: Option<string>) {}

	toJson(): TrackingApiDto {
		const json: TrackingApiDto = {
			campaign: this.campaign.orNull,
			source: this.source.orNull,
			adGroup: this.adGroup.orNull,
			landingPage: this.landingPage.orNull,
			url: this.url.orNull
		};
		return JsonConverter.removeEmptyFields(json);
	}

	isEmpty(): boolean {
		return this.campaign.isEmpty && this.source.isEmpty && this.adGroup.isEmpty && this.landingPage.isEmpty && this.url.isEmpty;
	}

	getText(): string {
		return this.campaign.map(c => `Campaign: ${c} `).getOrElse("") +
			this.source.map(s => `Source: ${s} `).getOrElse("") +
			this.adGroup.map(ad => `Ad Group: ${ad} `).getOrElse("") +
			this.landingPage.map(lp => `Landing Page: ${lp} `).getOrElse("") +
			this.url.map(u => `URL: ${u} `).getOrElse("");
	}
}